export default __webpack_public_path__ + "static/media/stadium.e5b952ce.jpg";